import { calculateDealTcv, calculateWeightedTcv } from "./deal-revenue";

function toFiniteNumber(value) {
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : 0;
}

function clampProbability(value) {
  const n = toFiniteNumber(value);
  if (n <= 0) return 0;
  if (n >= 100) return 100;
  return n;
}

export function calculatePipelineForecast(deals) {
  const items = Array.isArray(deals) ? deals : [];

  let totalTcv = 0;
  let weightedTcv = 0;
  let sumProbability = 0;

  for (const d of items) {
    const value = toFiniteNumber(calculateDealTcv(d));
    const probability = clampProbability(d?.probability);

    totalTcv += value;
    weightedTcv += toFiniteNumber(calculateWeightedTcv(d));
    sumProbability += probability;
  }

  const dealCount = items.length;
  const averageProbability = dealCount === 0 ? 0 : sumProbability / dealCount;

  return {
    totalTcv,
    weightedTcv,
    dealCount,
    averageProbability,
  };
}
